import { Formik } from 'formik'
import { Form, Modal, Row } from 'react-bootstrap'
import * as Yup from 'yup'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'
import CustomButton from '../../Button/CustomButton'
import CustomCloseButton from '../../Button/CustomCloseButton'
import TextField from '../../Input/TextInput'

const qtyPalletSchema = Yup.object().shape({
  qty: Yup.number()
    .required('Qty is required')
    .min(1, 'Qty must be greater than 0'),
  uom: Yup.string()
})

const QtyPalletForm = ({
  values,
  handleChange,
  handleBlur,
  errors,
  touched
}) => {
  return (
    <Row className="align-items-end">
      <TextField
        label=""
        name="qty"
        value={values.qty}
        handleChange={handleChange}
        handleBlur={handleBlur}
        touched={touched}
        errors={errors}
        placeholder="0.000"
        required={false}
        type="number"
        col={9}
        styles={{ height: '45px' }}
      />
      <div className="col-md-3 mb-3">
        <div
          className="d-flex align-items-center justify-content-center bg-light border rounded text-secondary fw-bold"
          style={{ height: '45px' }}
        >
          {values.uom || 'Pack'}
        </div>
      </div>
    </Row>
  )
}

function ModalEditQtyPallet({ detail, onHide, refreshData, ...props }) {
  const initialValues = {
    qty: detail.qty_unit || 0,
    uom: detail.uom_pack || 'Pack'
  }

  const handleSubmit = async (values) => {
    try {
      const res = await api.post(`/master/items/${detail.id}/qty`, {
        qty: values.qty
      })
      Common.showPopUpSuccessMessage(res.data.message)
      onHide()
      refreshData()
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  return (
    <Modal {...props} centered onHide={onHide} size="md">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
          QTY Items / pallet
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-2">
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={qtyPalletSchema}
          validateOnChange
          validateOnBlur
          onSubmit={handleSubmit}
        >
          {({
            handleBlur,
            handleSubmit,
            handleChange,
            values,
            errors,
            touched,
            isValid,
            setFieldValue
          }) => (
            <Form className="d-grid" onSubmit={handleSubmit}>
              <QtyPalletForm
                values={values}
                handleChange={handleChange}
                handleBlur={handleBlur}
                errors={errors}
                touched={touched}
              />
              <div className="d-flex justify-content-end gap-2 mt-3">
                <CustomCloseButton onClick={onHide} text="Cancel" />
                <CustomButton
                  onClick={handleSubmit}
                  variant="warning"
                  disabled={!isValid}
                  text="Save"
                  className="text-white px-4"
                />
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default ModalEditQtyPallet
